import { fetch } from 'whatwg-fetch';

const requestMiddleware = [];
export function applyRequestMiddleware( fn ) {
    requestMiddleware.push( fn );
}

export default function( url, options = {} ) {
    requestMiddleware.forEach( ( fn ) => {
        fn( url, options );
    } );

    return fetch( url, options );
}
